import { courseProgressInitState } from './CourseInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from '../Actions/ActionTypes';
import { CourseProgressResponse } from '../Types/CourseProgressResponse';

export const courseResultsReducer = (
  state: CourseProgressResponse = courseProgressInitState,
  action: IAction<CourseProgressResponse>
): CourseProgressResponse => {
  switch (action.type) {
    case COURSE_ACTIONS.FETCH_COURSE_PROGRESS:
      return { ...action.payload };

    default:
      return state;
  }
};
